import { render, staticRenderFns } from "./PostTypeIndex.vue?vue&type=template&id=9bf98796&scoped=true&"
import script from "./PostTypeIndex.vue?vue&type=script&lang=js&"
export * from "./PostTypeIndex.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PostTypeIndex.vue?vue&type=style&index=0&id=9bf98796&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9bf98796",
  "62aed73a"
  
)

export default component.exports